import { combineReducers } from "redux"
import payroll from "./payroll"
import employeeList from "./employeeList"

export default combineReducers({
  payroll,
  employee: employeeList
});
